import { Col, Image } from "react-bootstrap"
import { FaPlusCircle } from "react-icons/fa"
import { NavLink } from "react-router-dom"
const Service = (props) => {
  return (
    <Col lg={4} md={6} className="px-3 g-4" data-aos="fade-down">
        <div className="service-item rounded d-flex h-100">
            <div className="service-img rounded">
                <Image className="img-fluid" src={"asset/img/services/" + props.img} alt="service-1"/>
            </div>
            <div className="service-text rounded p-5">
                <div className="btn-square rounded-circle mx-auto mb-3">
                <Image className="img-fluid mt-3" src={"asset/img/services/" + props.icon} alt="icon"/>
                </div>
                <h4 className="mb-3">{props.title}</h4>
                <p className="mb-4">{props.description}</p>
                <NavLink className="btn btn-sm btn-outline-success" to=""><i className='me-2'><FaPlusCircle /></i>Read More</NavLink>
            </div>
        </div>
    </Col>
  )
}

export default Service